module.exports = "/_next/static/images/78a42ca062a62db3e7a31f5b35e76bee-image-lg.jpg.webp";